import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-5 py-2 border border-foreground-300/60 rounded-full text-xs text-foreground-500 font-label font-medium uppercase tracking-wider mb-8">
          {t('aboutTag')}
        </span>

        <h2 className="font-heading text-3xl md:text-5xl text-foreground-900 font-light leading-snug mb-16">
          {t('aboutTitle1')}
          <br />
          <span className="inline-flex items-baseline gap-2">
            {t('aboutTitle2')}
            <span className="w-8 h-8 flex items-center justify-center align-middle">
              <i className="ri-shopping-bag-3-line text-accent-500 text-2xl"></i>
            </span>
          </span>
          <br />
          <span className="inline-flex items-baseline gap-2">
            <span className="w-8 h-8 flex items-center justify-center align-middle">
              <i className="ri-file-list-3-line text-accent-400 text-2xl"></i>
            </span>
            {t('aboutTitle3')}
          </span>
        </h2>

        <div className="prose-custom max-w-2xl mx-auto">
          <p className="text-sm md:text-base text-foreground-600 font-body leading-relaxed md:leading-loose">
            {t('aboutContent')}
          </p>
        </div>
      </div>
    </section>
  );
}